import { Injectable, Output, Input, EventEmitter } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { DataModel, IDataModel } from './data.model'



export interface IEstadoItens extends IDataModel {
    codigo?:string,
    texto?: string,
    proximo?:string,
    finalizado?:boolean,
    img?: string,
    ordem?:number,
}

export class EstadoItens extends DataModel<IEstadoItens>  {
    constructor(private db: AngularFirestore) {
        super(db,'estadoItens');
    }

   getEstado(codigo:string,proc){
      let rt=null ;
      this.FDados.forEach(element => {
           if (element.codigo==codigo){
               rt = element;
               if (proc!=null) proc(rt);
               return rt;
           }
       });  

      /// nao esta na memoria ?
      if (rt==null){
         this.db.collection( this.tableNameFull,
           r => r.where("codigo","==",codigo))
         .snapshotChanges()
         .subscribe( d => {
             console.log(d);
         })  
      }

   }

   @Input()
   set verInativo(x){
      this.fVerInativo = x;
      this.snapshotChanges(); 
   }

   snapshotChanges() {
      this.reset(
        r => r.where('inativo', '==', this.fVerInativo)
       .orderBy("codigo","asc"));
      return super.snapshotChanges();
   }

   gerarNovoCodigo(proc){
       this.getNewID('codigo_estado_itens',proc);
   }

   updateOrInsert(id,item,proc,err){
       var old = id;
       //item.id = String(item.codigo);
       return super.updateOrInsert(item.id,item,r=>{
        if (proc ) proc(r);
       },err);
   }  

}
